import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboardOffice-component',
    templateUrl: './dashboardOffice.component.html'
})
export class DashboardOfficeComponent {

}
